export default __webpack_public_path__ + "static/media/feature-tal-5.6a13b5bc.png";